"use client";

import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { useEffect } from "react";
import { useI18n } from "@/locales/client";

interface SuccessStateProps {
  type: "bug" | "feedback";
  onClose: () => void;
}

export const SuccessState = ({ type, onClose }: SuccessStateProps) => {
  const t = useI18n();

  useEffect(() => {
    const timer = setTimeout(onClose, 2200);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="flex flex-col items-center gap-4 py-8 text-center"
    >
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{
          type: "spring",
          stiffness: 120,
          damping: 12,
          delay: 0.2,
        }}
        className="flex size-16 items-center justify-center rounded-full bg-green-100"
      >
        <CheckCircle2 className="size-10 text-green-500" />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.5 }}
      >
        <p className="text-[15px] font-semibold text-foreground">
          {type === "bug"
            ? t("feedbackModal.success.bugTitle")
            : t("feedbackModal.success.feedbackTitle")}
        </p>
        <p className="mt-1 text-[13px] leading-relaxed text-muted-foreground">
          {type === "bug"
            ? t("feedbackModal.success.bugDescription")
            : t("feedbackModal.success.feedbackDescription")}
        </p>
      </motion.div>
    </motion.div>
  );
};
